<template>
  <selectable-card :selected="selected" :disableOptions="true" :disableCheckbox="disableCheckbox"
    :disableTooltipText="disableTooltipText" @click:card="cardClicked" @click:checkbox="cardClicked">
    <template v-slot:content>
      <v-container class="text-body-2">
        <v-row>
          <v-col class="d-flex align-start">
            <div class="flex-grow-1">
              <div>PROCEDIMENTO</div>
              <div v-if="pagamentoItem.codigoProcedimento"><b>{{ pagamentoItem.codigoProcedimento | formatNullValue
                  }}</b></div>
              <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
              <span v-else>-</span>
            </div>
            <div class="flex-grow-1">
              <div>QUANTIDADE</div>
              <div><b>{{ pagamentoItem.quantidade }}</b></div>
            </div>
            <v-chip v-if="pagamentoItem.itemSistema && pagamentoItem.isRestoGuia" color="secondary" small>Restante de
              guia</v-chip>
            <v-chip v-if="pagamentoItem.isBaixa" color="secondary" small>Baixa</v-chip>
            <v-chip v-if="pagamentoItem.tipoRegistro === 'recurso'" color="secondary" small>Recurso</v-chip>
            <v-chip v-if="pagamentoItem.tipoRegistro === 'estorno'" color="secondary" small>Estorno</v-chip>
            <v-chip color="secondary" small>{{ isConciliado ? 'Conciliado' : 'Não conciliado' }}</v-chip>
          </v-col>
        </v-row>

        <v-row align="start">
          <v-col cols="6" class="py-0">
            <div>DESCRIÇÃO</div>
            <div v-if="pagamentoItem.descricaoProcedimento"><b>{{ pagamentoItem.descricaoProcedimento | formatNullValue
                }}</b></div>
            <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
            <span v-else>-</span>
          </v-col>
          <v-col cols="3" class="py-0">
            <div>EXECUÇÃO</div>
            <div v-if="pagamentoItem.dataExecucao"><b>{{ pagamentoItem.dataExecucao | formatDate | formatNullValue
                }}</b></div>
            <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
            <span v-else>-</span>
          </v-col>
          <v-col cols="3" class="py-0">
            <div>SENHA</div>
            <div v-if="pagamentoItem.senha"><b>{{ pagamentoItem.senha | formatNullValue }}</b></div>
            <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
            <span v-else>-</span>
          </v-col>
        </v-row>

        <v-row v-if="pagamentoItem.grauParticipacao">
          <v-col>
            <span>Grau de participação: <b>{{ pagamentoItemGrauParticipacaoLabels[pagamentoItem.grauParticipacao]
                }}</b></span>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div>NOME PROFISSIONAL EXECUTANTE</div>
            <div><b>{{ pagamentoItem.nomeProfissionalExecutante }}</b></div>
          </v-col>
          <v-col>
            <div>CÓD. PROFISSIONAL EXECUTANTE</div>
            <div><b>{{ pagamentoItem.codigoProfissionalExecutante }}</b></div>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div>INFORMADO</div>
            <div><b>{{ pagamentoItem.valorInformado | formatCurrency }}</b></div>
          </v-col>
          <v-col>
            <div>PROCESSADO</div>
            <div><b>{{ pagamentoItem.valorProcessado | formatCurrency }}</b></div>
          </v-col>
          <v-col>
            <div>PAGO</div>
            <div class="success--text"><b>{{ pagamentoItem.valorPago | formatCurrency }}</b></div>
          </v-col>
          <v-col>
            <div>GLOSADO</div>
            <div class="red--text"><b>{{ pagamentoItem.valorGlosado | formatCurrency }}</b></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>Guia Operadora</div>
            <div><b>{{ pagamentoItem.numeroGuiaOperadora }}</b></div>
          </v-col>
          <v-col>
            <div>Data Execução</div>
            <div><b>{{ pagamentoItem.dataExecucao | formatDate }}</b></div>
          </v-col>
          <v-col>
            <div>Nº do lote</div>
            <div><b>{{ pagamentoItem.numeroLote }}</b></div>
          </v-col>
          <v-col>
            <div>Nº do protocolo</div>
            <div><b>{{ pagamentoItem.numeroProtocolo != '' ? ((pagamentoItem.numeroProtocolo) ?? '-') : '-' }}</b></div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </selectable-card>
</template>

<style scoped>
.d-flex {
  gap: 8px;
}
</style>

<script>
import { mapGetters } from 'vuex'
import { formatCurrency } from '../../../libs'
import SelectableCard from '../../common/SelectableCard.vue'
import { pagamentoItemGrauParticipacaoLabels } from '@tradimus/api-conciliacao-client'

export default {
  data() {
    return {
      pagamentoItemGrauParticipacaoLabels
    }
  },
  components: {
    SelectableCard
  },
  props: {
    pagamentoItem: { type: Object, required: true },
    isUsuarioTradimus: Boolean
  },
  computed: {
    ...mapGetters('conciliacao', ['selectedPagamentoItensCount', 'selectedFaturamentoItensCount', 'hasSelectedFaturamentoItemConciliado', 'selectedFaturamentoItemConciliadoDates']),
    disableCheckboxByNN() {
      return this.selectedFaturamentoItensCount > 1 && this.selectedPagamentoItensCount >= 1 && !this.selected
    },
    hasAnyFaturamentoItemWithSameDateConciliacaoThanPagamentoItemSistema() {
      return this.pagamentoItem.itemSistema && this.selectedFaturamentoItemConciliadoDates.includes(this.pagamentoItem.dataPagamento)
    },
    disableCheckboxByItemSistema() {
      return this.hasAnyFaturamentoItemWithSameDateConciliacaoThanPagamentoItemSistema && this.pagamentoItem.itemSistema
    },
    disableCheckBoxByValorPagoAndValorGlosadoIsZero() {
      return false//this.pagamentoItem.valorPago === 0 && this.pagamentoItem.valorGlosado === 0 && this.pagamentoItem.tipoRegistro !== 'recurso'
    },
    disableCheckbox() {
      return this.disableCardCheckboxByNN || this.disableCheckboxByItemSistema || this.disableCheckBoxByValorPagoAndValorGlosadoIsZero
    },
    disableTooltipText() {
      if (this.disableCardCheckboxByNN) {
        return 'Não é possível selecionar mais de um item.'
      } else if (this.disableCheckboxByItemSistema) {
        return 'Não é permitido conciliar um item resto de guia com um item faturado já conciliado do mesmo pagamento.'
      } else if (this.disableCheckBoxByValorPagoAndValorGlosadoIsZero) {
        return 'Não é permitido conciliar item de pagamento sem valor pago e sem glosa.'
      } else {
        return ''
      }
    },
    selected() {
      return this.$store.getters['conciliacao/isPagamentoItemSelected'](this.pagamentoItem.id)
    },
    isConciliado() {
      return Boolean(this.pagamentoItem.conciliacaoItens?.length)
    }
  },
  methods: {
    cardClicked() {
      this.$emit('click:card', this.pagamentoItem, this.selected)
    },
    moreClicked(event) {
      this.$emit('click:more', event)
    }
  },
  filters: {
    formatCurrency(value) {
      return formatCurrency(value)
    },
    formatDate(dataISO) {
      if (!dataISO) return '-'
      const [data] = dataISO.split('T');
      const [ano, mes, dia] = data.split('-');
      return `${dia}/${mes}/${ano}`;
    },
  }
}
</script>
